import { CriteriaManagementGroupState } from './CriteriaManagementGroupTypes';

export const CriteriaManagementGroupActionTypes = {
  LOAD_CRITERIAMANAGEMENTGROUP_CRITERIA: 'loadCriteriaManagementGroupCriteria',
  LOADED_CRITERIAMANAGEMENTGROUP_CRITERIA: 'loadedCriteriaManagementGroupCriteria',
  LOAD_CRITERIAMANAGEMENTGROUP_CRITERIA_ERROR: 'loadCriteriaManagementGroupCriteriaError',
  LOAD_CRITERIAMANAGEMENTGROUP_CRITERIA_WITHMAPPING: 'loadCriteriaManagementGroupCriteriaWithMapping',
  LOADED_CRITERIAMANAGEMENTGROUP_CRITERIA_WITHMAPPING: 'loadedCriteriaManagementGroupCriteriaWithMapping',
  LOAD_CRITERIAMANAGEMENTGROUP_CRITERIA_WITHMAPPING_ERROR: 'loadCriteriaManagementGroupCriteriaWithMappingError',
  LOAD_OFFER_CONFIG: 'loadOfferConfig',
  LOADED_OFFER_CONFIG: 'loadedOfferConfig',
  LOAD_OFFER_CONFIG_ERROR: 'loadOfferConfigError',
};

export const DEFAULT_STATE: CriteriaManagementGroupState = {
  criteria: {},
  criteriaWithMapping: {},
  offerConfigSignupTableColumn: {}
};
